import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import TableCrudEnhanced from '../../components/TableCrudEnhanced';

const YearIndex = () => {
    const navigate = useNavigate();

    // Configuração de filtros
    const filterConfig = useMemo(() => [
        {
            type: "text",
            name: "yearNumber",
            label: "Year",
            placeholder: "Search by year number..."
        }
    ], []);

    // Colunas da tabela
    const columns = useMemo(() => [
        { 
            title: 'Year', 
            dataIndex: 'yearNumber', 
            key: 'yearNumber', 
            sortable: true,
            width: 100
        },
        { 
            title: 'Start Date', 
            dataIndex: 'beginDate', 
            key: 'beginDate', 
            sortable: true,
            type: 'date',
            render: (value) => moment(value).format("DD-MMM-YYYY")
        },
        { 
            title: 'End Date', 
            dataIndex: 'endDate', 
            key: 'endDate', 
            sortable: true,
            type: 'date',
            render: (value) => moment(value).format("DD-MMM-YYYY")
        },
        { 
            title: 'Active', 
            dataIndex: 'isActive', 
            key: 'isActive', 
            width: 100,
            render: (value, record, index, handleToggleActive) => (
                <span 
                    className={`badge ${value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleActive && handleToggleActive(record)}
                    title={`Click to ${value ? 'deactivate' : 'activate'}`}
                >
                    {value ? 'Active' : 'Inactive'}
                </span>
            )
        },        
        { 
            title: 'Deleted', 
            dataIndex: 'isDeleted', 
            key: 'isDeleted', 
            width: 100,
            render: (value, record, index, handleToggleActive, handleToggleDeleted) => (
                <span 
                    className={`badge ${!value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleDeleted && handleToggleDeleted(record)}
                    title={`Click to ${!value ? 'delete' : 'restore'}`}
                >
                    {!value ? 'Not Deleted' : 'Deleted'}
                </span>
            )
        }
    ], []);

    // Actions
    const actions = useMemo(() => [
        {
            label: 'Edit',
            onClick: (record) => navigate(`/year/edit/${record.yearID}`),
            type: 'primary'
        }
    ], [navigate]);

    return (
        <TableCrudEnhanced
            title="Glidepath Years"
            apiEndpoint="/Year/getAllPaginated"
            toggleActiveEndpoint="/Year/toggleActive"
            toggleDeletedEndpoint="/Year/toggleDeleted"
            newRoute="/year/new"
            columns={columns}
            filterConfig={filterConfig}
            actions={actions}
            rowKey="yearID"
            initialPageSize={10}
            enableFilters={true}
            showAddButton={true}
        />
    );
};

export default YearIndex;
